import { META_DATA_KEY, PLATFORM_KEY, PLUGIN_VERSION_KEY, SUB_PLATFORM_KEY, WEB_PLUGIN_VERSION_KEY, } from '@utils/constants';
import { mapPlatformFromParser } from '@utils/platformsMapper';
import { actions } from './reducer';
class Dispatch {
    constructor() {
        this.actions = actions;
    }
    /** Settings pushed by the core plugin over the `SETTINGS` messenger. */
    load(externalSettings) {
        return (dispatch, getState) => {
            if (!externalSettings)
                return;
            dispatch(actions.set(externalSettings));
            // Read post-dispatch: the payload may be partial, the state holds every setting reported so far.
            const { version, platform } = getState().settings;
            // Sent as the `x-metadata` header by every outbound request.
            sessionStorage.setItem(META_DATA_KEY, JSON.stringify({
                [PLUGIN_VERSION_KEY]: version,
                [PLATFORM_KEY]: mapPlatformFromParser(platform),
                [SUB_PLATFORM_KEY]: platform,
                [WEB_PLUGIN_VERSION_KEY]: WEB_PLUGIN_VERSION,
            }));
        };
    }
}
const SettingsDispatcher = new Dispatch();
export default SettingsDispatcher;
